import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../../services/api';

function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

 
  const languages = {
  am: { code: 'AM', name: t('languages.am') },
  de: { code: 'DE', name: t('languages.de') },
  en: { code: 'EN', name: t('languages.en') },
  es: { code: 'ES', name: t('languages.es') },
  fr: { code: 'FR', name: t('languages.fr') },
  it: { code: 'IT', name: t('languages.it') },
  pt: { code: 'PT', name: t('languages.pt') },
  ru: { code: 'RU', name: t('languages.ru') },
  sq: { code: 'SQ', name: t('languages.sq') },
  tr: { code: 'TR', name: t('languages.tr') }
};

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
    // Sync to backend for localized push notifications (fire-and-forget)
    api.saveLanguage(lng).catch(() => {});
  };

  const currentLang = languages[i18n.language] || languages.fr;

  return (
    <div ref={dropdownRef} style={{ position: 'relative' }}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          padding: '8px 16px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          border: 'none',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: '600',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          color: 'white',
          boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)',
          justifyContent: 'space-between',
          transition: 'all 0.2s',
          border: '1px solid #ffffff4d'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.4)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 2px 8px rgba(102, 126, 234, 0.3)';
        }}
      >
        <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <span style={{ fontSize: '16px' }}>{currentLang.flag}</span>
          <span>{currentLang.code}</span>
        </span>
        <span style={{ 
          fontSize: '10px', 
          transition: 'transform 0.2s',
          transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)'
        }}>
          ▼
        </span>
      </button>

      {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: 'calc(100% + 8px)',
            left: 0,
            background: 'white',
            border: '2px solid #e2e8f0',
            borderRadius: '12px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
            minWidth: '150px',
            zIndex: 1000,
            overflow: 'hidden',
            animation: 'slideDown 0.2s ease'
          }}
        >
          {Object.entries(languages).map(([code, lang]) => (
            <button
              key={code}
              onClick={() => changeLanguage(code)}
              style={{
                width: '100%',
                padding: '12px 16px',
                background: i18n.language === code ? '#f8fafc' : 'white',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                fontSize: '14px',
                fontWeight: '600',
                color: i18n.language === code ? '#667eea' : '#1e293b',
                textAlign: 'left',
                transition: 'background 0.2s'
              }}
              onMouseEnter={(e) => {
                if (i18n.language !== code) {
                  e.currentTarget.style.background = '#f8fafc';
                }
              }}
              onMouseLeave={(e) => {
                if (i18n.language !== code) {
                  e.currentTarget.style.background = 'white';
                }
              }}
            >
              <span style={{ fontSize: '20px' }}>{lang.flag}</span>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                <span style={{ fontWeight: '700' }}>{lang.code}</span>
                <span style={{ fontSize: '11px', color: '#64748b', fontWeight: '400' }}>
                  {lang.name}
                </span>
              </div>
              {i18n.language === code && (
                <span style={{ marginLeft: 'auto', color: '#667eea', fontSize: '16px' }}>✓</span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default LanguageSwitcher;